'use strict';

module.exports = {
  template: require('./cn-mail.html'),
  controller: require('./cn-mail.controller.js'),
  controllerAs: 'vm',

  bindings: {
    firstName: '@',
    lastName: '@',
    onReset: '&',
    onSubmit: '&',
    onChange: '&',
    modal: '<',
    title: '@',
    subject: '@',
    message: '@',
    signature: '@'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-mail/index.js
 ** module id = 65
 ** module chunks = 0
 **/